import React from "react";
import styled from "styled-components";
import { colorPickerState } from "@stores/vars";
import { useAtomValue } from "jotai";

const ColorPickWrap = styled.div`
  position: absolute;
  left: 1250px;
  top: 170px;
  width: 570px;
  height: 395px;
  border-radius: 15px;
  box-shadow: 0px 0px 0px 4px rgba(0, 0, 0, 0.2);
  background-color: #fff;
  z-index: 15;
`;

const ColorPickContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: var(--cur-colorpicker);
  border-radius: 15px;
  overflow: hidden;
  padding-top: 145px;
  box-sizing: border-box;
  transition: background-color 0.3s;
`;

const ColorWrap = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  background-color: #fff;
  padding: 5px;
  box-sizing: border-box;
`;

const ColorPickerBong = styled.div`
  position: absolute;
  display: inline-block;
  background-color: transparent;
  margin-top: -17px;
  width: 0;
  height: 0;
  left: 430px;
  transform: translatex(-50%);
  border-style: solid;
  border-width: 0 25px 20px 25px;
  border-color: transparent transparent var(--cur-colorpicker) transparent;
  transition: border-color 0.3s;
`;

const ColorBox = styled.div`
  width: 80px;
  height: 80px;
  &.lr {
    border-radius: 0 0 0 10px;
  }
  &:last-child {
    border-radius: 0 0 10px 0px;
  }
`;

const colors = [
  "#ff7878",
  "#ffbc7b",
  "#fff17a",
  "#7fffa0",
  "#78b8ff",
  "#768dff",
  "#d376ff",
  "#ff0000",
  "#ff7e00",
  "#ffe400",
  "#00b72f",
  "#0078ff",
  "#001ba1",
  "#ae00ff",
  "#830000",
  "#00148d",
  "#ffffff",
  "#bebebe",
  "#666666",
  "#333333",
  "#000000",
];

const ColorPicker = ({ onChange }) => {
  const isColorPicker = useAtomValue(colorPickerState);

  const setColor = (e) => {
    const color = e.target.getAttribute("data-color");
    onChange(color);
    document.body.style.setProperty("--cur-colorpicker", color);
  };

  return (
    isColorPicker && (
      <ColorPickWrap>
        <ColorPickerBong />
        <ColorPickContainer>
          <ColorWrap>
            {colors.map((color, i) => {
              return (
                <ColorBox
                  data-color={color}
                  className={i === 14 && "lr"}
                  onClick={setColor}
                  style={{
                    backgroundColor: color,
                  }}
                  key={i}
                />
              );
            })}
          </ColorWrap>
        </ColorPickContainer>
      </ColorPickWrap>
    )
  );
};

export default ColorPicker;
